import { type SelectOptionProps } from '@amzn/meridian/select/select-option';
import { COUNTRY_ID_MAPPING } from 'src/config/CountryIdMapping';
import { AccommodationTypeIds } from 'src/types/accommodationTypes';

export const getAccommodationTypesOptions = (countryId: number, includeAll = false): SelectOptionProps[] => {
  const selectableAcommodationTypes = [['AUSTIN', AccommodationTypeIds.AUSTIN]];

  if (countryId === COUNTRY_ID_MAPPING.USA_COUNTRY_ID) {
    selectableAcommodationTypes.push(['DALI', AccommodationTypeIds.DALI]);
  }
  if (countryId === COUNTRY_ID_MAPPING.CANADA_COUNTRY_ID) {
    selectableAcommodationTypes.push(['BALI', AccommodationTypeIds.BALI]);
  }
  if (includeAll) {
    selectableAcommodationTypes.push(['ANY', AccommodationTypeIds.ANY]);
  }

  return selectableAcommodationTypes.map(([name, value]) => {
    return { label: name, value: value, key: value };
  });
};
